import { c as _c } from "react/compiler-runtime";
import { useQuery as useTanstackQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
/**
 * A wrapper around tanstack query useQuery to avoid leaking framework specific code.
 * Should always be used from every publicly exposed query.
 *
 * @param options tanstack query options
 * @param queryClient tanstack query client
 * @returns query result api
 */
export function useQuery(options, queryClient) {
  const $ = _c(4);
  const query = useTanstackQuery(options, queryClient);
  let t0;
  if ($[0] !== query.data || $[1] !== query.isError || $[2] !== query.isLoading) {
    t0 = {
      data: query.data,
      isLoading: query.isLoading,
      isError: query.isError
    };
    $[0] = query.data;
    $[1] = query.isError;
    $[2] = query.isLoading;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}